<template>
  <a-radio-group
    :value="templateType"
    @change="onChange"
  >
    <a-radio-button
      v-for="item in templateList"
      :key="item.key"
      :value="item.key"
    >
      {{ item.value }}
    </a-radio-button>
  </a-radio-group>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('storeManage', ['templateList', 'templateType']),
  },
  methods: {
    onChange(e) {
      this.$store.commit('storeManage/updateTemplatetype', e.target.value);
    },
  },
};
</script>
